export default __webpack_public_path__ + "static/resume-gemm-ba47d34e2996ace45117def3709817f7.gif";